import { useKeycloak } from '@react-keycloak/web';
import { clearStorageData } from '../../../../utils/storage/storage';

export const useLogoutLavva = () => {
  const { keycloak } = useKeycloak();

  const handleLogoutLavva = () => {
    clearStorageData();
    keycloak.logout();
  };

  return {
    handleLogoutLavva,
  };
};
